export default { sha: '7d76161583949e1f8ca92f054789739625cd90f6', buildNumber: 'undefined' }
